import type { JSX } from 'react';

import { PetitionCard, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { useFeaturedVictories } from './hooks/useFeaturedVictories';

export function FeaturedVictories(): JSX.Element | null {
	const {
		data: { featuredVictories },
	} = useFeaturedVictories();
	const { translate, translatePlural } = useI18n();

	if (featuredVictories.length === 0) {
		return null;
	}

	return (
		<div className="container py-10">
			<Text as="h2" variant="heading" size="small" className="py-6">
				<Translate value="fe.pages.impact.victory_highlights" />
			</Text>
			<div className="grid grid-cols-1 justify-items-center gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
				{featuredVictories.map((petition) => (
					<PetitionCard
						key={petition.id}
						className="w-full"
						imageUrl={petition.photo?.petitionMedium.url}
						petitionId={petition.id}
						isVictory
						victoryLabel={translate('corgi.components.petition_card.victory')}
						petitionLinkUrl={`/p/${petition.slug}?source_location=impact_page`}
						signaturesLabel={translatePlural(
							'corgi.components.petition_card.signatures',
							petition.signatureState.signatureCount.displayed,
							{
								countLocalized: petition.signatureState.signatureCount.displayedLocalized,
							},
						)}
						title={petition.displayTitle}
					/>
				))}
			</div>
		</div>
	);
}
